import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import useAuth from 'src/hooks/useAuth';

type IProps = {
  name: string;
  int?: boolean;
};

type Props = IProps & TextFieldProps;

export const exceptThisSymbols = ['e', 'E', '+', '-'];

export default function RHFMoneyField({ name, type, int, ...other }: Props) {
  const { control, setValue } = useFormContext();
  const { user } = useAuth();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = parseFloat(e?.target?.value?.replace(/[^0-9.]/g, ''));
    if (inputValue < 0) inputValue = 0;

    setValue(name, inputValue);
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          type="number"
          fullWidth
          value={field.value}
          error={!!error}
          helperText={error?.message}
          onKeyDown={(e) =>
            exceptThisSymbols.includes(e.key) && e.preventDefault()
          }
          onChange={handleInputChange}
          {...other}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {user?.current_organization.country?.currency_symbol}
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
}
